<template>
  <BaseModal 
    :model-value="modelValue" 
    @update:model-value="$emit('update:modelValue', $event)"
    title="Как это работает?"
    size="large"
  >
    <div class="space-y-6">
      <div class="bg-[#242527] p-6 rounded-xl">
<!--        <h4 class="text-white text-lg font-medium mb-3">1. Создайте виртуальную карту</h4>-->
<!--        <p class="text-gray-300">-->
<!--          Быстро создавайте виртуальные карты для различных целей. Выберите валюту, лимиты и другие параметры в несколько кликов.-->
<!--        </p>-->

        <div class="flex align-center justify-center">
        <div class="ratio ratio-16x9">
          <iframe width="480" height="270" src="https://dzen.ru/embed/voFdaE2rAygs?from_block=partner&from=zen&mute=0&autoplay=0&tv=0" allow="autoplay; fullscreen; accelerometer; gyroscope; picture-in-picture; encrypted-media" frameborder="0" scrolling="no" allowfullscreen></iframe>
        </div>
        </div>


      </div>
      
<!--      <div class="bg-[#242527] p-6 rounded-xl">-->
<!--        <h4 class="text-white text-lg font-medium mb-3">2. Пополните баланс</h4>-->
<!--        <p class="text-gray-300">-->
<!--          Пополните баланс карты удобным для вас способом. Мы поддерживаем множество платежных методов.-->
<!--        </p>-->


<!--      </div>-->
      
<!--      <div class="bg-[#242527] p-6 rounded-xl">-->
<!--        <h4 class="text-white text-lg font-medium mb-3">3. Используйте для платежей</h4>-->
<!--        <p class="text-gray-300">-->
<!--          Используйте виртуальную карту для онлайн-платежей, подписок и других транзакций. Все операции защищены и отслеживаются в реальном времени.-->
<!--        </p>-->
<!--      </div>-->
      
<!--      <div class="bg-[#242527] p-6 rounded-xl">-->
<!--        <h4 class="text-white text-lg font-medium mb-3">4. Управляйте своими картами</h4>-->
<!--        <p class="text-gray-300">-->
<!--          Контролируйте все свои карты в одном месте. Устанавливайте лимиты, замораживайте и размораживайте карты, просматривайте историю транзакций.-->
<!--        </p>-->
<!--      </div>-->
    </div>
    
    <template #footer>
      <div class="flex justify-end">
        <button 
          @click="$emit('update:modelValue', false)" 
          class="bg-white text-black px-6 py-2 rounded-full font-medium hover:bg-gray-100 transition-colors"
        >
          Понятно
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { defineComponent } from 'vue'
import BaseModal from './BaseModal.vue'

export default defineComponent({
  name: 'HowItWorksModal',
  components: {
    BaseModal
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue']
})
</script>
